import * as types from './mutation_types'

export default {
  [types.POST_SHOW_RESET] (state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      retrieved: null,
    })
  },

  [types.POST_SHOW_SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.POST_SHOW_SET_RETRIEVED] (state, retrieved) {
    Object.assign(state, { retrieved })
  },

  [types.POST_SHOW_TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/post/show/mutations.js